module.exports = __webpack_public_path__ + "img/flow1.90d4c7a7.png";